import axios from 'axios'

const url = process.env.REACT_APP_URL

export const addSingleReference = async (sku, shortWording, longWording) => {
  try {
    const res = await axios.post(`${url}/reference/singleReference`, {
      sku: sku,
      shortWording: shortWording,
      longWording: longWording
    })
    console.log(res)
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const addReference = async (list: string[]): Promise<any> => {
  try {
    const res = await axios.post(url + "/reference/addReference", {
      referenceList: list
    })
    console.log(res)
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const addS3Reference = async (json, filename) => {
  try {
    const res = await axios.post(url + '/aws/putReference', {
      json: json, filename: filename
    })
    return res
  } catch (err) {
    console.log(err)
  }
}

export const getReference = async () => {
  try {
    const res = await axios.get(url + "/reference/getReference")
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const deleteReference = async (id) => {
  try {
    const res = await axios.delete(`${url}/reference/${id}`)
    return res
  } catch (err) {

  }
}